import React, { useMemo } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import {
	Label,
	ListWrapper,
	Row,
	UploadLabel,
	Wrapper,
} from './FileList.styles';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const FileList = ({ list }) => {
	const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
	const gridStyle = useMemo(() => ({ height: '200px' }), []);
	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			resizable: true,
			sortable: true,
			filter: true,
		};
	}, []);

	const columnDefs = [
		{ field: 'author_name', headerName: 'Data Uploaded by' },
		{ field: 'status', headerName: 'Pipeline Status' },
		{ field: 'published_time', headerName: 'Data Uploaded at' },
	];

	const gridOptions = {
		modules: AllModules,
		rowData: list,
		columnDefs,
		defaultColDef,
		pagination: true,
		paginationPageSize: 10,
		// domLayout: 'autoHeight',
	};

	if (list.length === 0) {
		return (
			<Wrapper>
				<Row>
					<ApIcon iconName="cloud_upload" iconColor={colors.grey8} />
					<Label>No data uploaded</Label>
				</Row>
			</Wrapper>
		);
	}

	return (
		<ListWrapper>
			<UploadLabel>Last Uploaded: </UploadLabel>
			<div style={containerStyle}>
				<div
					style={gridStyle}
					className="ag-theme-balham"
				>
					<AgGridReact {...gridOptions} />
				</div>
			</div>
		</ListWrapper>
	);
};

export default FileList;
